var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DoubleColumnLayout as BaseDoubleColumnLayout, Box, Typography, doubleColumnLayoutClasses as baseDoubleColumnLayoutClasses, mergeSlotProps, } from "@vividtheory/minerva-lab";
import React, { useState } from "react";
import { ButtonBase, Drawer, FlexScrollArea, FlexScrollAreaContainer, Grid, IconButton, } from "../components";
import { ArrowDropUpOutline, CloseOutline } from "../icons";
export const doubleColumnLayoutClasses = baseDoubleColumnLayoutClasses;
export const DoubleColumnLayout = (_a) => {
    var { left, right, rightBreakpoint = "cmd", leftBreakpoint = "cmd", rightHeader, leftHeader, leftWidth = "auto", rightWidth = "auto", hideRightHeaderOnDrawerOpen = false, slotProps } = _a, props = __rest(_a, ["left", "right", "rightBreakpoint", "leftBreakpoint", "rightHeader", "leftHeader", "leftWidth", "rightWidth", "hideRightHeaderOnDrawerOpen", "slotProps"]);
    const [leftOpen, setLeftOpen] = useState(false);
    const [rightOpen, setRightOpen] = useState(false);
    return (React.createElement(Box, { height: "100%", width: "100%", sx: {
            containerType: "inline-size",
        } },
        React.createElement(FlexScrollAreaContainer, null,
            React.createElement(FlexScrollArea, null,
                React.createElement(BaseDoubleColumnLayout, Object.assign({ left: left, right: right, slotProps: mergeSlotProps({
                        left: {
                            sx: {
                                display: "none",
                                breakpoints: {
                                    [leftBreakpoint]: {
                                        width: leftWidth,
                                        display: "block",
                                    },
                                },
                            },
                        },
                        right: {
                            sx: {
                                display: "none",
                                breakpoints: {
                                    [rightBreakpoint]: {
                                        width: rightWidth,
                                        display: "block",
                                    },
                                },
                            },
                        },
                    }, slotProps) }, props))),
            left && (React.createElement(ButtonBase, { sx: {
                    marginX: 4,
                    marginBottom: right ? 0 : 4,
                    width: "auto",
                    padding: 4,
                    border: 1,
                    borderColor: (theme) => theme.palette.stroke[100],
                    borderRadius: (theme) => theme.radius.xs2,
                    breakpoints: {
                        [leftBreakpoint]: {
                            display: "none",
                        },
                    },
                }, onClick: () => {
                    setLeftOpen(!leftOpen);
                } },
                React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center", gap: 2 },
                    React.createElement(Grid, { item: true }, leftHeader &&
                        typeof leftHeader === "string" ? (React.createElement(Typography, { variant: "body2", fontWeight: "semibold" }, leftHeader)) : (leftHeader)),
                    React.createElement(ArrowDropUpOutline, null)))),
            right && (React.createElement(ButtonBase, { sx: {
                    marginTop: left ? 2 : 0,
                    marginX: 4,
                    marginBottom: 4,
                    width: "auto",
                    padding: 4,
                    border: 1,
                    borderColor: (theme) => theme.palette.stroke[100],
                    borderRadius: (theme) => theme.radius.xs2,
                    breakpoints: {
                        [rightBreakpoint]: {
                            display: "none",
                        },
                    },
                    color: (theme) => theme.palette.surface.main,
                }, onClick: () => {
                    setRightOpen(!rightOpen);
                } },
                React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center", gap: 2 },
                    React.createElement(Grid, { item: true }, rightHeader &&
                        typeof rightHeader === "string" ? (React.createElement(Typography, { variant: "body2", fontWeight: "semibold" }, rightHeader)) : (rightHeader)),
                    React.createElement(ArrowDropUpOutline, null))))),
        left && (React.createElement(Drawer, { placement: "bottom", size: "95dvh", open: leftOpen, onOpenChange: (open) => setLeftOpen(open), sx: {
                background: (theme) => theme.palette.background.main,
                borderTopLeftRadius: (theme) => theme.radius.xs,
                borderTopRightRadius: (theme) => theme.radius.xs,
            } },
            React.createElement(FlexScrollAreaContainer, null,
                React.createElement(Grid, { container: true, justifyContent: leftHeader ? "space-between" : "flex-end", sx: {
                        padding: 4,
                        color: (theme) => theme.palette.surface.main,
                    } },
                    leftHeader && typeof leftHeader === "string" ? (React.createElement(Typography, { variant: "body2", fontWeight: "semibold" }, leftHeader)) : (leftHeader),
                    React.createElement(IconButton, { variant: "minimal", onClick: () => setLeftOpen(false) },
                        React.createElement(CloseOutline, null))),
                React.createElement(FlexScrollArea, null, left)))),
        right && (React.createElement(Drawer, { placement: "bottom", size: "95dvh", open: rightOpen, onOpenChange: (open) => setRightOpen(open), sx: {
                background: (theme) => theme.palette.background.main,
                borderTopLeftRadius: (theme) => theme.radius.xs,
                borderTopRightRadius: (theme) => theme.radius.xs,
            } },
            React.createElement(FlexScrollAreaContainer, null,
                React.createElement(Grid, { container: true, justifyContent: rightHeader && !hideRightHeaderOnDrawerOpen
                        ? "space-between"
                        : "flex-end", sx: {
                        padding: 4,
                    } },
                    hideRightHeaderOnDrawerOpen ? null : rightHeader &&
                        typeof rightHeader === "string" ? (React.createElement(Typography, { variant: "body2", fontWeight: "semibold" }, rightHeader)) : (rightHeader),
                    React.createElement(IconButton, { variant: "minimal", onClick: () => setRightOpen(false) },
                        React.createElement(CloseOutline, null))),
                React.createElement(FlexScrollArea, null,
                    right,
                    " "))))));
};
//# sourceMappingURL=DoubleColumnLayout.js.map